import type { Step } from "react-joyride";

export const leaveEntitlementsTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້າສິດລາຕໍ່ປີ. ຈັດການສິດລາຂອງພະນັກງານຕໍ່ປີ ເລືອກພະນັກງານເບິ່ງສິດລາ ຫຼື ສ້າງໃໝ່. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="leave-entitlements-toolbar"]',
    content: "ຫົວຂໍ້ ແລະ ປຸ່ມສ້າງສິດລາໃໝ່.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="leave-entitlements-filter"]',
    content: "ກັ່ນຕອງ ຫຼື ເລືອກພະນັກງານເບິ່ງສິດລາຕໍ່ປີ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="leave-entitlements-table"]',
    content: "ຕາຕະລາງສິດລາ ຫຼື ລາຍການພະນັກງານ.",
    placement: "top",
  },
];
